module.exports = __webpack_public_path__ + "static/img/FITmenu10.edc6c64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/FITmenu10.png
// module id = r8ob
// module chunks = 1